<nz-table
  #nzTableRef
  class="company-nztable-bridge"
  [nzData]="tableData()"
  [nzLoading]="loading()"
  [nzBordered]="bordered()"
  [nzFrontPagination]="frontPagination()"
  [nzShowPagination]="frontPagination() && showPagination()"
  [nzShowSizeChanger]="frontPagination()"
  [nzScroll]="scrollConfig()"
  [nzSize]="tableSize()"
  [nzTableLayout]="tableLayout()"
  [nzTitle]="title()"
  [nzFooter]="footer()"
  [nzPaginationType]="paginationType()"
  [nzPaginationPosition]="paginationPosition()"
  [nzSimple]="simplePagination()"
>
  <thead>
    <tr>
      @if (expandable()) {
        <th nzWidth="48px"></th>
      }
      @for (col of visibleColumns(); track col.field) {
        <th
          [nzWidth]="columnWidths().get(col.field) ?? null"
          [nzLeft]="col.pinned === 'left'"
          [nzRight]="col.pinned === 'right'"
          [nzShowSort]="col.sortable === true"
          [nzSortFn]="getSortFn(col)"
          [nzSortDirections]="getSortFn(col) ? ['ascend', 'descend', null] : []"
          [nzFilters]="$any(col.filterOptions ?? [])"
          [nzFilterFn]="col.filterFn ?? false"
          [nzFilterMultiple]="col.filterMultiple !== false"
          [nzShowFilter]="!!(col.filterOptions && col.filterOptions.length > 0)"
          [nzEllipsis]="ellipsis()"
        >
          {{ col.headerName ?? col.field }}
        </th>
      }
    </tr>
  </thead>

  <tbody>
    @for (row of nzTableRef.data; track $index; let i = $index) {
      <tr class="company-nztable-bridge__row">
        @if (expandable()) {
          <td
            [nzExpand]="expandedIndices().has(i)"
            (nzExpandChange)="onExpandChange(i, $event)"
          ></td>
        }
        @for (col of visibleColumns(); track col.field) {
          <td
            class="company-nztable-bridge__cell"
            [nzLeft]="col.pinned === 'left'"
            [nzRight]="col.pinned === 'right'"
            [nzEllipsis]="ellipsis()"
            (click)="onCellClick(row, i, col, $event)"
          >
            @if (col.cellTemplate) {
              <ng-container
                [ngTemplateOutlet]="col.cellTemplate"
                [ngTemplateOutletContext]="buildCellContext(row, i, col)"
              />
            } @else {
              @let cellText = formatCellText(row, col);
              @if (ellipsis()) {
                <span
                  class="company-nztable-bridge__ellipsis-text"
                  nz-tooltip
                  [nzTooltipTitle]="ellipsisTooltip()"
                  (mouseenter)="onEllipsisTextEnter($event, cellText)"
                >
                  {{ cellText }}
                </span>
              } @else {
                {{ cellText }}
              }
            }
          </td>
        }
      </tr>

      @if (expandable() && expandTemplate()) {
        <tr [nzExpand]="expandedIndices().has(i)">
          <td [attr.colspan]="expandColSpan()">
            <ng-container
              [ngTemplateOutlet]="expandTemplate()!"
              [ngTemplateOutletContext]="{ $implicit: row, row: row, rowIndex: i }"
            />
          </td>
        </tr>
      }
    }
  </tbody>
</nz-table>
